module.exports = __webpack_public_path__ + "img/partnership_01.3b263ac5.jpg";